import { Promotion } from "@/@types";
import Link from "next/link";
import { ROUTES } from "@/config/routes";
import { FallbackImage } from "../common";
import { Skeleton } from "../ui/skeleton";

type Props = {
  item: { promotions: Promotion[] };
};

const formatDate = (dateString: string) => {
  const date = new Date(dateString);
  return date.toLocaleDateString("es-ES", {
    day: "2-digit",
    month: "long",
    year: "numeric",
  });
};

const PromotionCard = ({ item }: Props) => {
  const promotion = item.promotions[0];
  const formattedDate = formatDate(promotion.endDate);

  const promotionUrl = promotion.link
    ? promotion.link
    : ROUTES.promotions.details(promotion.slug);

  return (
    <Link
      href={promotionUrl}
      target={promotion.isBlank === "1" ? "_blank" : "_self"}
      rel="noopener noreferrer"
      className="relative border-l border-gray02 flex flex-col bg-white group hover:border-yellow02 h-full gap-4"
    >
      <div className="w-full overflow-hidden p-2 pb-0">
        <div className="aspect-[100/47] relative">
          <FallbackImage
            fill
            className="object-cover border rounded-md"
            src={promotion.fullMedia}
            alt={promotion.title}
          />
        </div>
      </div>

      <div className=" px-4 flex flex-col flex-1">
        <div className="flex-1 text-dark02">
          <h3
            className={`text-base font-bold overflow-hidden text-ellipsis uppercase line-clamp-1 min-h-[24px]`}
          >
            {promotion.title}
          </h3>

          {promotion.hideDate === 2 && (
            <p className=" uppercase">VIG / {formattedDate}</p>
          )}
        </div>
      </div>

      <div className="w-full">
        <div className="text-right text-dark02 group-hover:font-semibold bg-gray01 py-2 px-4 w-full group-hover:bg-yellow02">
          VER MÁS
        </div>
      </div>
    </Link>
  );
};

export default PromotionCard;


export function PromotionCardSkeleton() {
  return (
    <div className="relative border-l border-gray02 flex flex-col bg-white h-full gap-4">
      <div className="w-full overflow-hidden p-2 pb-0">
        <div className="aspect-[100/47] relative">
          <Skeleton className="absolute inset-0" />
        </div>
      </div>

      <div className="px-4 flex flex-col flex-1">
        <div className="flex-1 space-y-2">
          <Skeleton className="h-6 w-3/4" />
          <Skeleton className="h-6 w-1/2" />
        </div>
      </div>

      <div className="w-full">
        <Skeleton className="h-[40px] rounded-none" />
      </div>
    </div>
  );
}
